// src/libs/toastStore.ts
import { useState, useEffect } from 'react';

export interface ToastItem {
    id: string;
    message: string;
    type: 'success' | 'error' | 'info';
}

let listeners: React.Dispatch<React.SetStateAction<ToastItem[]>>[] = [];
let toastList: ToastItem[] = [];

export const toastStore = {
    // 토스트 추가
    push(message: string, type: ToastItem['type']) {
        const id = crypto.randomUUID();
        toastList = [{ id, message, type }];
        listeners.forEach((l) => l([...toastList]));

        // 자동 제거
        setTimeout(() => {
            toastList = toastList.filter((t) => t.id !== id);
            listeners.forEach((l) => l([...toastList]));
        }, 3000);
    },

    // 구독
    subscribe(listener: React.Dispatch<React.SetStateAction<ToastItem[]>>) {
        listeners.push(listener);
        listener([...toastList]); // 초기값
        return () => {
            listeners = listeners.filter((l) => l !== listener);
        };
    }
};

// React hook 형태로 export
export const useToastStore = () => {
    const [toasts, setToasts] = useState<ToastItem[]>([]);
    useEffect(() => toastStore.subscribe(setToasts), []);
    return toasts;
};
